import React from 'react';
import { motion as Motion } from 'framer-motion';
import { siteData } from '../data';
import { FileText, ShoppingBag } from 'lucide-react';

const Menu = () => {
  return (
    <div className="pt-32 md:pt-40">
      <div className="max-w-4xl mx-auto px-4 pb-24">
        <div className="text-center mb-16">
          <Motion.h1 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-4xl md:text-5xl font-bold text-white mb-4 uppercase tracking-tight"
          >
            {siteData.menu.title}
          </Motion.h1>
          
          <Motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.15 }}
            className="mt-6 inline-flex items-center gap-3 bg-zinc-900/80 border border-white/10 px-5 py-2.5 rounded-full text-zinc-200 text-sm font-medium shadow-md"
          >
            <span className="flex h-2.5 w-2.5 rounded-full bg-emerald-500 animate-pulse" />
            <span>Vi kan også findes på Wolt</span>
          </Motion.div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8">
            <Motion.a 
              href={siteData.company.orderUrl}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.2 }}
              className="inline-flex items-center gap-2 bg-red-600 border-2 border-red-600 text-white px-6 py-3 rounded-full font-semibold hover:bg-red-700 hover:border-red-700 hover:-translate-y-1 transition-all duration-300 cursor-pointer shadow-lg shadow-red-600/20"
            >
              <ShoppingBag className="h-5 w-5" /> Bestil online her
            </Motion.a>
            <Motion.a 
              href="/menukort/banh%20mi%20menukort.pdf"
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.25 }}
              className="inline-flex items-center gap-2 bg-transparent border-2 border-white text-white px-6 py-3 rounded-full font-semibold hover:bg-white/10 hover:-translate-y-1 transition-all duration-300 cursor-pointer"
            >
              <FileText className="h-5 w-5" /> Hent menukort som PDF
            </Motion.a>
          </div>
        </div>

        <div className="space-y-16">
          {siteData.menu.categories.map((category) => (
            <div 
              key={category.name}
            >
              <h2 className="text-2xl font-bold text-white mb-8 pb-2 border-b-2 border-white/10 uppercase tracking-wide">
                {category.name}
              </h2>
              <div className={category.name === 'Drikkevarer' ? "grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-4" : "grid gap-8"}>
                {category.items.map((item) => (
                  <div key={item.name} className={`flex flex-col group ${category.name === 'Drikkevarer' ? 'py-2 border-b border-white/5' : ''}`}>
                    <div className="flex justify-between items-baseline gap-4">
                      <div className="flex-1">
                        <h3 className={`${category.name === 'Drikkevarer' ? 'text-lg' : 'text-xl'} font-semibold text-white group-hover:text-zinc-400 transition-colors uppercase tracking-wide`}>{item.name}</h3>
                        {item.description && (
                          <p className="text-zinc-400 mt-2 whitespace-pre-line leading-relaxed">{item.description}</p>
                        )}
                      </div>
                      <div className={`${category.name === 'Drikkevarer' ? 'text-lg text-zinc-200' : 'text-xl text-white'} font-bold whitespace-nowrap ml-4`}>
                        {item.price}
                      </div>
                    </div>
                    {item.optionBoxes && (
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6">
                        {item.optionBoxes.map((box, bIdx) => (
                          <div 
                            key={bIdx}
                            className="bg-zinc-900/70 border border-white/10 rounded-xl p-4 sm:p-5 flex flex-col justify-start hover:border-white/20 transition-all duration-200 shadow-sm"
                          >
                            <h4 className="text-xs sm:text-sm font-bold text-zinc-100 uppercase tracking-wider mb-3 pb-2.5 border-b border-white/10">
                              {box.title}
                            </h4>
                            <ul className="space-y-2">
                              {box.items.map((opt, oIdx) => (
                                <li key={oIdx} className="text-xs sm:text-sm text-zinc-300 flex items-start gap-2 leading-relaxed">
                                  <span className="text-red-500 font-bold select-none">•</span>
                                  <span>{opt}</span>
                                </li>
                              ))}
                            </ul>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-red-600 py-16 text-center text-white">
        <div className="max-w-4xl mx-auto px-4">
          <h3 className="text-2xl font-bold mb-4 uppercase tracking-wide">Allergier?</h3>
          <p className="text-red-50 text-lg">Spørg venligst personalet for information om allergener i vores retter.</p>
        </div>
      </div>
    </div>
  );
};

export default Menu;
